import PropTypes from "prop-types"
import { useEffect } from "react"
import { connect } from "react-redux"

import {
  toggleAddonChoice,
  updateChoiceDirectly,
} from "areas/product/store/actions"
import Image from "components/ui/image"
import Shimmer from "components/ui/shimmer"
import { to_currency } from "helpers/number"
import { filterProductOptionsV2 } from "helpers/product/product-filtering"
import { cn } from "styles/utils"

const ProductAddons = ({
  productAddons,
  adminMode,
  header,
  lid,
  line_item,
  prefStore,
  selectedProductAddons,
  toggleAddon,
  updateChoice,
  wizardLoading,
}) => {
  const hideAddons =
    !productAddons?.length ||
    wizardLoading ||
    header.params_olid_present ||
    adminMode

  useEffect(() => {
    if (
      !hideAddons &&
      lid &&
      Object.keys(line_item?.product_addons || {}).length > 0
    ) {
      updateChoice({
        disabled: true, // To skip processing addon choice in other sagas
        pref: "addon",
        value: Object.keys(line_item.product_addons),
      })
    }
  }, [hideAddons, lid, line_item])

  if (hideAddons) {
    return null
  }
  return (
    <div
      aria-labelledby="product-addons-heading"
      className="bg-white pt-16"
      role="group"
    >
      <h2 className="text-18 mb-16 font-semibold" id="product-addons-heading">
        Add-ons
      </h2>
      {productAddons.map((addon) => {
        const selected = selectedProductAddons.includes(addon.set_key)

        return (
          <div className="mb-16" key={`addon-${addon.id}`}>
            {!prefStore || (lid && !line_item) ? (
              <Shimmer className="w-full" style={{ height: "122px" }} />
            ) : (
              <label
                aria-label={addon.display_name}
                className="border-grey-200 focus-within:outline-primary flex cursor-pointer items-center border pl-10 focus-within:outline-2 focus-within:outline-offset-0"
                htmlFor={`product-addon-${addon.set_key}`}
              >
                <input
                  aria-checked={selected}
                  checked={selected}
                  className="sr-only"
                  data-style-code={addon.style_code}
                  id={`product-addon-${addon.set_key}`}
                  onChange={() => toggleAddon(addon.set_key)}
                  type="checkbox"
                />
                <div
                  aria-hidden
                  className={cn(
                    "h-(--base-width) w-(--base-width) before:z-2 after:h-(--after-width) after:w-(--after-width) after:z-1 before:h-(--before-height) before:w-(--before-width) relative mr-6 before:absolute before:left-6 before:top-3 before:rotate-45 before:border-b-2 before:border-r-2 before:border-b-white before:border-r-white after:absolute after:rounded-full after:border after:border-black",
                    selected
                      ? "before:block after:bg-black"
                      : "before:hidden after:bg-white"
                  )}
                  style={{
                    "--after-width": "17px",
                    "--base-width": "18px",
                    "--before-height": "9px",
                    "--before-width": "5px",
                  }}
                />
                <Image
                  alt={addon.display_name}
                  className="ml-10 mr-12"
                  height="120"
                  width="120"
                  {...(addon.custom_image
                    ? {
                        src: addon.custom_image,
                      }
                    : {
                        fallback: addon.images[0],
                        srcSet: addon.images[1],
                      })}
                />
                <div className="text-14 leading-14">
                  <h3 className="text-14 mb-12 font-semibold">
                    {addon.display_name}
                  </h3>
                  <p className="font-medium">{to_currency(addon.surcharge)}</p>
                </div>
              </label>
            )}
          </div>
        )
      })}
    </div>
  )
}

ProductAddons.propTypes = {
  adminMode: PropTypes.bool,
  header: PropTypes.object,
  lid: PropTypes.string,
  line_item: PropTypes.object,
  prefStore: PropTypes.bool,
  productAddons: PropTypes.array,
  selectedProductAddons: PropTypes.array,
  toggleAddon: PropTypes.func,
  updateChoice: PropTypes.func,
  wizardLoading: PropTypes.string,
}

const mapStateToProps = (state) => {
  const choices = state.choices || {}
  const productAddons = state.wizard.addons
    ? filterProductOptionsV2(
        state.wizard.addons.filter((addon) => addon.in_stock),
        choices,
        true
      )
    : []
  const selectedProductAddons = state.choices.addon
    ? state.choices.addon.value
    : []

  const lid = state.wizardUI.lid
  let line_item = null

  if (lid) {
    line_item = (state.cart.line_items || []).find((li) => li.id === lid)
  }

  const prefStore = state.wizardUI.prefStore
  const wizardLoading = state.wizard.loading

  return {
    adminMode: state.wizard.adminMode,
    header: state.wizard.header,
    lid,
    line_item,
    prefStore,
    productAddons,
    selectedProductAddons,
    wizardLoading,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    toggleAddon: (setKey) => dispatch(toggleAddonChoice(setKey)),
    updateChoice: (data) => dispatch(updateChoiceDirectly("addon", data)),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(ProductAddons)
